import React from "react";
import { createRoot } from 'react-dom/client';

import NotificationsManager from "./NotificationsManager";
import Notification, { Color } from "./Notification";
import createContainer from "./createContainer";

const containerElement = createContainer();
let notify;
const root = createRoot(containerElement);

root.render(
  <React.StrictMode>
  <NotificationsManager
    setNotify={(notifyFn) => {
      notify = notifyFn;
    }}
  />
  </React.StrictMode>
  // containerElement
);

export { Notification, Color };

export function getApiMessage(value, fallback) {
  var text = toNotifyText(value);
  return text || fallback || "";
}

function toNotifyText(value) {
  if (value == null || value === "") return "";
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  if (React.isValidElement(value)) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(toNotifyText).filter(Boolean).join(", ");
  }
  if (typeof value === "object") {
    if (value.message != null) return toNotifyText(value.message);
    if (value.detail != null) return toNotifyText(value.detail);
    if (value.msg != null) return toNotifyText(value.msg);
    // FastAPI-style validation item fallback
    if (value.loc != null && value.type != null) {
      try {
        return JSON.stringify(value);
      } catch (e) {
        return "Validation error";
      }
    }
    try {
      return JSON.stringify(value);
    } catch (e) {
      return "Unexpected error";
    }
  }
  return String(value);
}

export function info(children, autoClose) {
  return notify({
    color: Color.info,
    children:<div>{toNotifyText(children)}</div>,
    autoClose,
  });
}

export function success(children, autoClose) {
  return notify({
    color: Color.success,
    children:<div>{toNotifyText(children)}</div>,
    autoClose,
  });
}

export function warning(children, autoClose) {
  return notify({
    color: Color.warning,
    children:<div>{toNotifyText(children)}</div>,
    autoClose,
  });
}

export function error(children, autoClose) {
  return notify({
    color: Color.error,
    children:<div>{toNotifyText(children)}</div>,
    autoClose,
  });
}